import React from 'react';
import { Box, Grid, Typography, Divider, Stack } from '@mui/material';
import { formatDateReplaceHour, getReasonStr } from '../utils/lib';
import CachedAvatar from '../components/CachedAvatar';
import { useTranslation } from 'react-i18next';
import { useConfig } from '../providers/ConfigProvider';

const OwnerRecentListItem = ({owner, onClick, onPetClick, isMultiUser = false, onQuickEmailEdit, onQuickPhoneEdit}) => {
  const { t } = useTranslation();
  const { config } = useConfig();
  
  return (
    <Box
      onClick={() => onClick(owner)} 
      sx={{ 
        px: 2, 
        py: 1, 
        display: 'flex', 
        flexDirection: 'column', 
        width: '100%',
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: 'action.hover',
        },
      }}
    >
      <Grid container spacing={2} alignItems="center">
        {/* Thumbnail */}
        <Grid item>
          <CachedAvatar 
            sx={{ width: 56, height: 56, bgcolor: 'grey.800' }} 
            alt="Thumbnail"
            src={owner.thumb_url || ''}
          />
        </Grid>
        
        {/* Name and Email/Phone */}
        <Grid item xs>
          <Typography 
            variant="subtitle1" 
            noWrap
          >
            {owner.name}
          </Typography>

          <Stack 
            direction="row" 
            spacing={1} 
            divider={<Divider orientation="vertical" flexItem />}
          >
            <Typography 
              variant="caption" 
              noWrap 
              sx={{ 
                flex: 1,
                cursor: !owner.phone ? 'pointer' : 'inherit',
                color: !owner.phone ? 'primary.main' : 'inherit',
                textDecoration: !owner.phone ? 'underline' : 'none',
                '&:hover': !owner.phone ? {
                  backgroundColor: 'action.hover',
                } : {}
              }}
              onClick={(e) => {
                if (!owner.phone && onQuickPhoneEdit) {
                  e.stopPropagation();
                  onQuickPhoneEdit(owner);
                }
              }}
            >
              {owner.phone || t('common.mobile')}
            </Typography>
            <Typography 
              variant="caption" 
              noWrap 
              sx={{ 
                flex: 1,
                cursor: !owner.email ? 'pointer' : 'inherit',
                color: !owner.email ? 'primary.main' : 'inherit',
                textDecoration: !owner.email ? 'underline' : 'none',
                '&:hover': !owner.email ? {
                  backgroundColor: 'action.hover',
                } : {}
              }}
              onClick={(e) => {
                if (!owner.email && onQuickEmailEdit) {
                  e.stopPropagation();
                  onQuickEmailEdit(owner);
                }
              }}
            >
              {owner.email || t('common.email')}
            </Typography>
          </Stack>
        </Grid>

        {/* Last Visit, Reason and user */}
        <Grid item>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end',
              textAlign: 'right',
              minWidth: '120px',
            }}
          >          
            <Typography 
              variant="caption" 
              noWrap
            >
              {formatDateReplaceHour(owner.last_visit, config)}
            </Typography>
            <Typography 
              variant="caption" 
              noWrap
            >
              {owner.reason != null && owner.reason !== ''
                ? getReasonStr(owner.reason)
                : owner.reason_es}
            </Typography>
            {isMultiUser && (
              <Typography 
                variant="caption" 
                noWrap
              >
                {owner.user.name}
              </Typography>
            )}
          </Box>
        </Grid>
      </Grid>

      {/* Pets */}
      <Grid container sx={{ mt: 2 }}>
        <Grid item xs={1} />
        <Grid item xs={11}>
          <Box 
            sx={{
              overflowX: 'auto',
              whiteSpace: 'nowrap',
              '&::-webkit-scrollbar': {
                height: '6px',
              },
              '&::-webkit-scrollbar-track': {
                background: '#f1f1f1',
                borderRadius: '3px',
              },
              '&::-webkit-scrollbar-thumb': {
                background: '#888',
                borderRadius: '3px',
              },
            }}
          >
            <Box 
              sx={{ 
                display: 'inline-flex', 
                gap: 2,
                py: 0.5,
              }}
            >
              {owner.pets.map((pet) => (
                <Typography
                  key={pet.id}
                  onClick={(event) => onPetClick(event, pet)}
                  variant="subtitle2" 
                >
                  {pet.name}
                </Typography>
              ))}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default OwnerRecentListItem;
